var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsAiUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6667C7.0777 14.6667 6.21103 14.4917 5.39992 14.1417C4.58881 13.7917 3.88325 13.3139 3.28325 12.7083C2.68325 12.1028 2.20825 11.3944 1.85825 10.5833C1.50825 9.77222 1.33325 8.91111 1.33325 8C1.33325 6.25556 1.91103 4.75556 3.06659 3.5C4.22214 2.24445 5.64436 1.53334 7.33325 1.36667V3.36667C6.18881 3.52222 5.23603 4.03611 4.47492 4.90834C3.71381 5.78056 3.33325 6.81111 3.33325 8C3.33325 9.28889 3.78881 10.3889 4.69992 11.3C5.61103 12.2111 6.71103 12.6667 7.99992 12.6667C8.73325 12.6667 9.41936 12.5111 10.0583 12.2C10.6971 11.8889 11.2333 11.4667 11.6666 10.9333L13.3999 11.9333C12.7999 12.7667 12.0277 13.4306 11.0833 13.925C10.1388 14.4194 9.11103 14.6667 7.99992 14.6667ZM14.0999 10.7L12.3666 9.7C12.4666 9.43334 12.5416 9.15834 12.5916 8.875C12.6416 8.59167 12.6666 8.3 12.6666 8C12.6666 6.81111 12.286 5.78056 11.5249 4.90834C10.7638 4.03611 9.81103 3.52222 8.66658 3.36667V1.36667C10.3555 1.53334 11.7777 2.24445 12.9333 3.5C14.0888 4.75556 14.6666 6.25556 14.6666 8C14.6666 8.48889 14.6221 8.96111 14.5333 9.41667C14.4444 9.87222 14.2999 10.3 14.0999 10.7Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAiUsage);
export default __webpack_public_path__ + "static/media/icons-ai-usage.dd1a445b.svg";
export { ForwardRef as ReactComponent };